// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LinkWrap_wrap__3YbXo"};